import { MainHeader } from "./layout";
import { HeaderContainer } from "./styledComponents";

const Header = () => {


  return (
    <HeaderContainer>
      <MainHeader />
    </HeaderContainer>
  );
};

export default Header;
